import { useMemo } from "react";
import { withNamespaces } from "react-i18next";
import { useHistory } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import { Button, Card, CardBody, CardTitle } from "reactstrap";
import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_FORMAT } from "src/common/constants";
import {
    INFORMATION_ACCORDIONS,
    buildInformationTabPath,
} from "src/modules/data-protection/pages/admin/software/details/tabs-content/information/helpers/accordionDeepLink";
import { MAIN_HEADER_STYLE } from "../../constants/tableStyles";

const DocumentationGap = ({ t, softwareId, gap = {}, lastUpdate }) => {
    const history = useHistory();
    const dateUtils = new DateUtils();
    const items = gap.items || [];

    const columns = useMemo(
        () => [
            {
                dataField: "rowIndex",
                text: "#",
                isDummyField: true,
                headerStyle: MAIN_HEADER_STYLE,
                style: { width: "48px" },
                formatter: (_cell, _row, index) => index + 1
            },
            {
                dataField: "label",
                text: t("Requirement"),
                headerStyle: MAIN_HEADER_STYLE,
                formatter: (cell) => t(cell)
            },
            {
                dataField: "status",
                text: t("Documentation gap"),
                headerStyle: MAIN_HEADER_STYLE,
                formatter: (cell) => (
                    <strong>{t(cell === "missing" ? "Yes" : "No")}</strong>
                )
            },
            {
                dataField: "action",
                text: t("Action Needed"),
                isDummyField: true,
                headerStyle: MAIN_HEADER_STYLE,
                formatter: (_cell, row) =>
                    row.status === "missing" ? (
                        <Button
                            color="primary"
                            size="sm"
                            type="button"
                            onClick={() =>
                                history.push(
                                    buildInformationTabPath(
                                        softwareId,
                                        INFORMATION_ACCORDIONS.ATTACHMENTS
                                    )
                                )
                            }
                        >
                            {t("Add Document")}
                        </Button>
                    ) : (
                        "—"
                    )
            }
        ],
        [history, softwareId, t]
    );

    return (
        <Card className="overview-sustainability-card h-100 mb-0">
            <CardBody>
                <CardTitle className="overview-section-title mb-3">
                    {t("Documentation Gap")}
                </CardTitle>
                <div className="table-responsive">
                    <BootstrapTable
                        keyField="code"
                        data={items}
                        columns={columns}
                        bordered={false}
                        striped={false}
                        hover={false}
                        classes="table align-middle mb-0"
                        noDataIndication={() => t("No documentation gaps.")}
                    />
                </div>
                <div className="overview-documentation-gap__footer">
                    <span>
                        {t("Missing")} {gap.summary?.missing ?? 0}
                        {" / "}
                        {t("Applicable")} {gap.summary?.applicable ?? 0}
                    </span>
                    {lastUpdate && (
                        <span>
                            {t("Last Update")}:{" "}
                            {dateUtils.convertDateToDate(
                                lastUpdate,
                                INTERNATIONAL_DATE_FORMAT
                            )}
                        </span>
                    )}
                </div>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(DocumentationGap);
